import { render, staticRenderFns } from "./decoration8.vue?vue&type=template&id=720570ae&scoped=true"
import script from "./decoration8.vue?vue&type=script&lang=js"
export * from "./decoration8.vue?vue&type=script&lang=js"
import style0 from "./decoration8.vue?vue&type=style&index=0&id=720570ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720570ae",
  null
  
)

export default component.exports